"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeStyles = void 0;
var _1 = __importDefault(require("."));
/**
 * Utility function to help generate styles which are based on the Mortar Theme. This utility helps provide
 * consistent type information, as well as a fallback default theme for use in test environments (to avoid
 * requiring every test be wrapped in a jss ThemeProvider).
 */
function makeStyles(styleSpec) {
    if (process.env.NODE_ENV === 'test') {
        if (typeof styleSpec === 'function') {
            return styleSpec(_1.default);
        }
    }
    return styleSpec;
}
exports.makeStyles = makeStyles;
